import useGetCustomerProfileInitialValues from './useGetCustomerProfileInitialValues'

export default useGetCustomerProfileInitialValues
